import React, {useEffect} from "react";
import "../Css/Accounts.css";
import {ProfileSection} from "../Containers/ProfileSection";
import {SkillSection} from "../Containers/SkillSection";
import {ExperienceSection} from "../Containers/ExperienceSection";
import {EducationSection} from "../Containers/EducationSection";
import {LanguageSection} from "../Containers/LanguageSection";

export function DiaconuIlieCv() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const profile = {
            title: 'Founder and Full-Stack Developer',
            name: 'Diaconu Ilie Marian',
            src: '/images/prof-ili.jpg',
            linkedin: 'https://www.linkedin.com/in/ilie-marian-diaconu-655710241',
            quote: 'I am a dedicated web developer with a passion for building modern, responsive,\n' +
                '                    and scalable web applications. With a strong foundation in programming principles,\n' +
                '                    I have hands-on experience working with technologies like JavaScript, React, Node.js,\n' +
                '                    and PHP. My focus is on crafting user-friendly solutions that address real-world\n' +
                '                    challenges, from e-commerce platforms to ERP systems. I continuously refine my skills\n' +
                '                    and explore innovative technologies to stay ahead in the ever-evolving tech landscape.'
        };

    const skills = [
        { name: "HTML/CSS/SCSS", from: "2021-01-01" },
        { name: "JavaScript", from: "2021-01-01" },
        { name: "React", from: "2021-01-01" },
        { name: "TypeScript", from: "2021-08-19" },
        { name: "Twig", from: "2021-08-19" },
        { name: "WordPress", from: "2021-08-19" },
        { name: "PHP", from: "2021-08-19" },
        { name: "Symfony", from: "2021-08-19" },
        { name: "PostgreSQL", from: "2021-08-19" },
        { name: "Linux", from: "2021-08-19" },
        // ChatGPT launch
        { name: "AI-assisted development", from: "2022-11-30" },
        // Cursor's public release (March 2023)
        { name: "LLM integration", from: "2023-03-01" },
    ];

    const experiences = [
        {
            link: "https://www.smarttasksoftware.com/",
            title: "Founder and Full-Stack Developer at Smart Task Software",
            from: "2024-03-30",
            to: undefined,
            responsibilities: [
                "Responsible for managing and updating the Smart Task Software website and ongoing projects, including websites, ERP systems, and other software solutions."
            ]
        },
        {
            link: "https://wecodepixels.com/",
            title: "Full-Stack Developer at We Code Pixels",
            from: "2021-08-20",
            to: "2024-04-30",
            responsibilities: [
                "Started my career in programming, gaining valuable experience through diverse projects and honing my technical skills.",
                "Implementing front-end solutions for customer’s requests, as well as providing estimates.",
                "Updating and maintaining company website."
            ]
        }
    ];

    const education = [
        {
            link: "https://www.unitbv.ro/",
            title: "Bachelor in Traffic and Transport Engineering",
            from: "2018-01-01",
            to: "2022-01-01",
        }
    ];

    const languages = [
        { name: "English", level: "Full working proficiency" },
        { name: "Romanian", level: "Native" },
    ]

    return (
        <div className="cv-container">
            <h1 className="cv-name">Diaconu Ilie Marian</h1>
            <div className="team-divider"/>
            <ProfileSection profile={profile}/>
            <SkillSection skills={skills}/>
            <ExperienceSection experiences={experiences}/>
            <EducationSection education={education}/>
            <LanguageSection languages={languages}/>
        </div>
    );
}
